import { motion } from "framer-motion";
import { ShieldOff, Rocket, Sparkles, Palette, ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import FloatingBubbles from "@/components/FloatingBubbles";

const FEATURES = [
  { icon: ShieldOff, title: "100% Ad-Free", text: "No interruptions, just adventures" },
  { icon: Rocket, title: "Episodes First", text: "Watch new stories before anyone else" },
  { icon: Sparkles, title: "Exclusive Minisodes", text: "Bonus bites you won't find on YouTube" },
  { icon: Palette, title: "Activity Sheets", text: "Print, color and play along with Bubz" },
];

export default function BubzPlus() {
  return (
    <section
      id="bubzplus"
      data-testid="bubzplus-section"
      className="relative overflow-hidden bg-bubz-ink py-20 sm:py-28"
    >
      <FloatingBubbles count={8} testidPrefix="bubzplus-bubble" />
      <div className="pointer-events-none absolute -left-24 top-10 h-72 w-72 rounded-full bg-bubz-grape/30 blur-3xl" />
      <div className="pointer-events-none absolute -right-20 bottom-0 h-80 w-80 rounded-full bg-bubz-sky/25 blur-3xl" />

      <div className="relative z-10 mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
        <Reveal>
          <motion.span
            data-testid="bubzplus-stamp"
            className="inline-block -rotate-3 rounded-2xl border-[3px] border-bubz-sun px-6 py-2 font-display text-sm font-bold uppercase tracking-[0.25em] text-bubz-sun"
            whileHover={{ rotate: 3 }}
          >
            Coming Soon
          </motion.span>
        </Reveal>

        <Reveal delay={0.1}>
          <h2
            data-testid="bubzplus-wordmark"
            className="mt-8 font-display text-6xl font-bold leading-none text-white sm:text-8xl lg:text-[9rem]"
          >
            BUBZ<span className="text-bubz-sun">+</span>
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base font-semibold text-white/70 sm:text-lg">
            The home of every BUBZ &amp; BUBBLES adventure — a brand-new streaming playground
            landing soon at <span className="text-bubz-sky">www.bubzplus.com</span>
          </p>
        </Reveal>

        <div className="mx-auto mt-12 grid max-w-4xl gap-4 sm:grid-cols-2">
          {FEATURES.map((f, i) => (
            <Reveal key={f.title} delay={0.15 + i * 0.08}>
              <motion.div
                data-testid={`bubzplus-feature-${i}`}
                className="flex items-center gap-4 rounded-3xl border border-white/10 bg-white/5 p-5 text-left backdrop-blur-sm"
                whileHover={{ scale: 1.03, backgroundColor: "rgba(255,255,255,0.1)" }}
              >
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-bubz-pink/20">
                  <f.icon size={22} className="text-bubz-pink" />
                </span>
                <span>
                  <span className="block font-display text-lg font-semibold text-white">{f.title}</span>
                  <span className="block text-sm font-semibold text-white/60">{f.text}</span>
                </span>
              </motion.div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.4}>
          <motion.a
            data-testid="bubzplus-link"
            href="https://www.bubzplus.com"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-12 inline-flex items-center gap-2 rounded-full bg-bubz-sun px-8 py-4 font-display text-lg font-semibold text-bubz-ink shadow-[0_10px_30px_rgba(255,208,52,0.35)]"
            whileHover={{ scale: 1.06, rotate: -1 }}
            whileTap={{ scale: 0.94 }}
          >
            www.bubzplus.com <ArrowUpRight size={20} />
          </motion.a>
          <p className="mt-5 text-sm font-bold text-white/50">
            Until launch day, catch every episode free on YouTube
          </p>
        </Reveal>
      </div>
    </section>
  );
}
